var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BackgroundVideo",
    {
      staticClass: "landing-cover pl-0 pr-0",
      style: {
        width: _vm.$vuetify.breakpoint.mdAndDown ? "100%" : "120%",
        height: _vm.$vuetify.breakpoint.mdAndDown ? "500px" : "836px",
        "margin-left": _vm.$vuetify.breakpoint.mdAndDown ? "0" : "-10%",
        position: _vm.$vuetify.breakpoint.mdAndDown ? "" : "relative",
      },
      attrs: {
        img: _vm.cover,
        sources: [_vm.coverVideo],
        overlay: "linear-gradient(45deg,#2a4ae430,#fb949e6b)",
      },
    },
    [
      _c(
        "v-layout",
        {
          class: [
            "landing-cover-layout",
            { "is-small": _vm.$vuetify.breakpoint.mdAndDown },
          ],
          staticStyle: { height: "100%" },
          attrs: { column: "", "align-center": "", "justify-center": "" },
        },
        [
          _c("h1", { staticClass: "landing-cover-title white--text" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("components.cover.title")) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "landing-cover-subtitle white--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("components.cover.subtitle")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm.downloadGames.length && _vm.$vuetify.breakpoint.mdAndUp
            ? _c(
                "v-menu",
                {
                  attrs: { top: "", "offset-y": "", color: "secondary" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass:
                                      "landing-cover-freetoplay-icon",
                                    attrs: {
                                      "aria-label": _vm.$t(
                                        "components.cover.buttonPlay"
                                      ),
                                      "aria-haspopup": true,
                                      "aria-expanded":
                                        attrs["aria-expanded"] || false,
                                    },
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t("components.cover.buttonPlay")
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1269745992
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { role: "menu" } },
                    [
                      _c(
                        "v-list-item",
                        { attrs: { color: "accent", role: "menuitem" } },
                        [
                          _c("v-list-item-avatar", [
                            _c("img", {
                              attrs: { src: _vm.logo, alt: "GOZ logo" },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            { staticClass: "text-center" },
                            [
                              _c("v-list-item-title", [
                                _vm._v("Start your journey"),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-subtitle", [
                                _vm._v("Download the game"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    "aria-label": "Download game client",
                                    text: "",
                                    icon: "",
                                    color: "#a4bdef",
                                  },
                                },
                                [_c("v-icon", [_vm._v("fad fa-gamepad")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.downloadGames, function (game) {
                        return _c(
                          "v-list-item",
                          {
                            key: game.id,
                            attrs: {
                              role: "menuitem",
                              link: "",
                              tabindex: "0",
                              "aria-label": "Download " + _vm.$t(game.title),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.goTo(game.link)
                              },
                            },
                          },
                          [
                            game.useImageAsBackground
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "v-list-item-background-image",
                                    style:
                                      "background-image: url('" +
                                      game.img +
                                      "')",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "v-list-item-download-labels",
                                      },
                                      [
                                        game.isNew
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "downloadLabel downloadNew",
                                              },
                                              [_vm._v("New")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        game.isRecommend
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "downloadLabel downloadRecommend",
                                              },
                                              [_vm._v("Recommend")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        game.isRecommend
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "downloadLabel downloadComingSoon",
                                              },
                                              [_vm._v("Coming Soon")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : [
                                  _c(
                                    "v-list-item-avatar",
                                    { attrs: { size: "25" } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "aria-hidden": true } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(game.icon) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "text-no-wrap" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t(game.title)) +
                                          "\n              "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "v-list-item-download-labels",
                                        },
                                        [
                                          game.isNew
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "downloadLabel downloadNew",
                                                },
                                                [_vm._v("New")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          game.isRecommend
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "downloadLabel downloadRecommend",
                                                },
                                                [_vm._v("Recommend")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          game.isRecommend
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "downloadLabel downloadComingSoon",
                                                },
                                                [_vm._v("Coming Soon")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _c(
                "button",
                {
                  staticClass: "landing-cover-freetoplay-icon",
                  attrs: {
                    "aria-label": _vm.$t("components.cover.buttonPlay"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goTo("#")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("components.cover.buttonPlay")) +
                      "\n    "
                  ),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }